<template>
  <div>
    <div
      class="field"
      :class="{
        error: v.$error,
        valid: !v.$invalid,
        required: v.$params.required,
      }"
    >
      <label>{{ label }}</label>
      <slot></slot>
      <div class="note">
        <small><slot name="note"></slot></small>
      </div>
      <div class="errmsg">
        <small>{{ message }}</small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["label", "v"],
  computed: {
    message() {
      if (this.v.$error) {
        for (let key in this.$options.messages) {
          if (this.v[key] === false) {
            return this.$options.messages[key](this.v);
          }
        }
      } else {
        return null;
      }
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  messages: {
    //Add more messages here when you need, the key should be the same as the name of the validator
    required: (v) => "This field is required",
    email: (v) => "Must be a valid e-mail",
    alphaNum: (v) => "May only contain letters and numbers",
    numeric: (v) => "May only contain numbers",
    minLength: (v) =>
      "Must be at least " + v.$params.minLength.min + " characters",
    maxLength: (v) =>
      "Must be no more than " + v.$params.minLength.min + " characters",
    goodPassword: (v) => "", //The password rules are always displayed, so no need to show a message
    sameAs: (v) => "Must be same as " + v.$params.sameAs.eq,
  },
};
</script>
<style>
.field {
  margin-bottom: 10px;
}
.form-group .required label::after {
  color: red;
}
.form-group .valid input {
  /*border-color: green;*/
}
.form-group .valid input label::after {
  /*color: green;*/
}
.form-group .error {
}
.form-group .error input {
  border-color: red;
}

.form-group .error .note {
  /*font-size: 12px;*/
}
.form-group .error .errmsg {
  color: red !important;
}

button.invalid {
  opacity: 0.5;
}
</style>
